'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('common/components/button');

var _button2 = _interopRequireDefault(_button);

var _hfReactHelper = require('common/utils/hf-react-helper');

var _hfReactHelper2 = _interopRequireDefault(_hfReactHelper);

var _setTimeout = require('common/utils/set-timeout');

var _setTimeout2 = _interopRequireDefault(_setTimeout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TwoOptionTabPane = _react2['default'].createClass({
    displayName: 'TwoOptionTabPane',

    propTypes: {
        image: _react2['default'].PropTypes.string,
        frozenImage: _react2['default'].PropTypes.string,
        title: _react2['default'].PropTypes.string.isRequired,
        heading_1: _react2['default'].PropTypes.string.isRequired,
        description_1: _react2['default'].PropTypes.string.isRequired,
        heading_2: _react2['default'].PropTypes.string.isRequired,
        description_2: _react2['default'].PropTypes.string.isRequired
    },
    getInitialState: function getInitialState() {
        return {
            animating: true,
            hover: false
        };
    },
    componentDidMount: function componentDidMount() {

        // TODO: refactor this bit - defer animation handling to whatever
        // is actually animating this component vs making this assumption (CC)
        (0, _setTimeout2['default'])(function () {
            this.setState({ animating: false });
        }.bind(this), 15000);
    },

    // TODO: remove after refactoring bit below to use CSS instead
    onMouseEnter: function onMouseEnter() {
        this.setState({ 'hover': true });
    },
    onMouseLeave: function onMouseLeave() {
        this.setState({ 'hover': false });
    },
    render: function render() {
        return _jsx('div', {}, void 0, _jsx('div', {
            className: 'show-for-large-up large-6 columns'
        }, void 0, _jsx('img', {
            src: this.state.animating ? this.props.image : this.props.frozenImage,
            className: 'embedded-image'
        })), _jsx('div', {
            className: 'small-12 large-6 small-text-center large-text-left columns'
        }, void 0, _jsx('h3', {}, void 0, this.props.title), _jsx('div', {
            className: 'row l-padding-v-20'
        }, void 0, _jsx('div', {
            className: 'small-10 large-12 small-centered large-uncentered columns'
        }, void 0, _jsx('div', {
            className: 'small-5 columns l-no-gutter'
        }, void 0, _jsx('p', {
            className: 'b'
        }, void 0, this.props.heading_1), _jsx('p', {}, void 0, this.props.description_1)), _jsx('div', {
            className: 'small-2 columns'
        }, void 0, _jsx('img', {
            src: require('./or.png'),
            className: 'or-image'
        })), _jsx('div', {
            className: 'small-5 columns l-no-gutter'
        }, void 0, _jsx('p', {
            className: 'b'
        }, void 0, this.props.heading_2), _jsx('p', {}, void 0, this.props.description_2)))), _jsx('div', {
            className: 'row'
        }, void 0, _jsx('div', {
            className: 'small-12 columns'
        }, void 0, _jsx('a', {
            href: 'http://info.hellosign.com/api-demo.html',
            onMouseEnter: this.onMouseEnter,
            onMouseLeave: this.onMouseLeave
        }, void 0, _jsx('img', {
            src: this.state.hover ? require('./learn_more_hover.png') : require('./learn_more.png')
        }))))));
    }
});

module.exports = TwoOptionTabPane;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/api/two-option-tab-pane.jsx
 ** module id = 722
 ** module chunks = 0
 **/